// Declared twice so that docs appear when selecting colors
export interface OpticPalette extends Record<string, string> {
  /** **#E2F1E7** Green */
  readonly optic10: string;
  /** **#CAE7D2** Green */
  readonly optic30: string;
  /** **#9CD6AA** Green */
  readonly optic60: string;
  /** **#5DBE75** Green */
  readonly opticPrimary: string;
  /** **#22973F** Green */
  readonly optic80: string;
  /** **#0A6A21** Green */
  readonly optic90: string;
}

export const opticPalette: OpticPalette = {
  optic10: '#E2F1E7',
  optic30: '#CAE7D2',
  optic60: '#9CD6AA',
  opticPrimary: '#5DBE75',
  optic80: '#22973F',
  optic90: '#0A6A21',
};
